import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL
let UserType = JSON.parse(localStorage.getItem("WWINGS_USER_TYPE"))


export const getRenewalAPI = async (payload) => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  if (UserType === "Admin") {
    return await axios.get(`${apiBaseUrl}/allrenewalTracking`,

      { headers }
    )
  } else {
    return await axios.get(`${apiBaseUrl}/myrenewalTracking`,

      { headers }
    )
  }
}


export const findRenewalAPI = async payload => {
  try {
    const countDay = payload

    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/findpolicy`,
      countDay,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error adding lead:", error)
    throw error
  }
}

export const getAllRenewalTriggerAPI = async () => {
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Content-Type": "application/json",
    Authorization: apiToken,
    Accept: "application/json",
    "Cache-Control": "no-cache",
  }

  return await axios.get(`${apiBaseUrl}/get-all-auto-renewal-triggers`, { headers })
}

export const createRenewalTriggerAPI = async payload => {
  try {

    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/create-auto-renewal-trigger`, payload,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error Creating Renewal Trigger:", error)
    throw error
  }
}


export const updateRenewalTriggerAPI = async payload => {
  try {

    let apiToken = JSON.parse(localStorage.getItem("authUser"))
    const headers = {
      "Access-Control-Allow-Origin": "*",
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
      "Cache-Control": "no-cache",
    }

    const response = await axios.post(
      `${apiBaseUrl}/update-trigger-status`, payload,
      {
        headers,
      }
    )
    return response
  } catch (error) {
    console.error("Error Updating Renewal Trigger:", error)
    throw error
  }
}

export const whatsAppRenewalMessage = async payload => {
  try {
    let apiToken = JSON.parse(localStorage.getItem("authUser"))

    const headers = {
      "Content-Type": "application/json",
      Authorization: apiToken,
      Accept: "application/json",
    }

    // payload must include policy_id
    const response = await axios.post(
      `${apiBaseUrl}/PolicyExpiryWhatsApp`,
      payload,
      { headers }
    )

    return response
  } catch (error) {
    throw error
  }
}